import { createCustomEnum } from "./customEnum";

const GatewayConfigurationOption = createCustomEnum({
	NewGateway: {
		name: "new_gateway",
		value: 1,
		displayName: "New Gateway",
	},
	FileBuildOnly: {
		name: "file_build_only",
		value: 2,
		displayName: "File Build Only",
	},
});

export default GatewayConfigurationOption;
